import Api from '@/services/Api'

export default {
    getAllFechaRegistro(){
        return Api().get('/fechaRegistro/getAll')
    },
    // createCentroCostos(datos){
    //     return Api().post('/centroCostos/create',datos)
    // },
    updateFechaRegistro(datos){
        return Api().put('/fechaRegistro/update',datos)
    },
}